import { BaseResponse } from './internal/baseresponse';
import { TransactionInb } from 'app/model/shared/transaction/transaction';

export class TransactionCheckOtherSenderResult extends BaseResponse {
  data: Array<TransactionInb> = new Array<TransactionInb>();
}



// WEBPACK FOOTER //
// ./src/app/response/transactioncheckothersender.ts